import type { JSX } from 'react';
import { type FieldValues, useController } from 'react-hook-form';
import { ListboxComponent } from './AutoCompleteVirtualize';
import { RHFAutoComplete } from './RHFAutoComplete';
import type { RHFAutocompleteProps } from './types';
import { useSelectAllDeselectAll } from './useSelectAllDeselectAll';

export const RHFAutoCompleteVirtualize = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
  TFieldValues extends FieldValues = FieldValues,
>({
  name,
  control,
  itemSize,
  slotProps,
  ...rest
}: RHFAutocompleteProps<T, Multiple, DisableClearable, FreeSolo, TFieldValues>): JSX.Element => {
  const {
    field: { value },
  } = useController({
    control,
    name,
  });

  const listboxProps = useSelectAllDeselectAll({
    handleChange: rest.onChange,
    options: rest.options,
    currentValue: value,
    showSelectAllOptions: rest.showSelectAllOptions,
  });

  return (
    <RHFAutoComplete
      name={name}
      control={control}
      disableListWrap
      slotProps={{
        ...slotProps,
        listbox: {
          component: ListboxComponent,
          ...listboxProps,
          ...(itemSize !== undefined ? { itemSize } : {}),
          ...slotProps?.listbox,
        },
      }}
      {...rest}
    />
  );
};
